import { api } from "./api";

export function sendVisitBeacon() {
  try {
    if (sessionStorage.getItem("fw-visit-sent")) return;
    let vid = localStorage.getItem("fw-vid");
    if (!vid) {
      vid = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("fw-vid", vid);
    }
    api.post("/metrics/visit", { vid }).catch(() => {});
    sessionStorage.setItem("fw-visit-sent", "1");
  } catch { /* storage unavailable (private mode) */ }
}
